module.exports = __webpack_public_path__ + "Frame391-eee16969.webp";